import React from 'react'
import { Button } from '../../../../components/Button/Button'
import { useNavigate } from 'react-router-dom'

export const createAppIntegrationSuccess = (name: string): React.FC => {
  return () => {
    const navigate = useNavigate()
    return (
      <div className='d-flex flex-column gap-3 align-items-center text-center'>
        <div className='paragraph-medium'>
          You've unlocked {name} and all Ultimate features. Head to Apps to enable {name} for your team.
        </div>
        <div className='d-flex align-items-center justify-content-center'>
          <Button variant='primary' className='button-medium' onClick={() => navigate('/account/integration-settings/oauth2apps')}>
            Go to Apps
          </Button>
        </div>
      </div>
    )
  }
}
